import { render, staticRenderFns } from "./problem-handling.vue?vue&type=template&id=7f0e75ba&scoped=true&"
import script from "./problem-handling.vue?vue&type=script&lang=js&"
export * from "./problem-handling.vue?vue&type=script&lang=js&"
import style0 from "./problem-handling.vue?vue&type=style&index=0&id=7f0e75ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0e75ba",
  null
  
)

export default component.exports